// 'use client';

// import * as React from 'react';
// import * as ProgressPrimitive from '@radix-ui/react-progress';

// import { cn } from '@/lib/utils/command';

// const Progress = React.forwardRef<
//   React.ElementRef<typeof ProgressPrimitive.Root>,
//   React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
// >(({ className, value, ...props }, ref) => (
//   <ProgressPrimitive.Root
//     ref={ref}
//     className={cn(
//       'relative h-4 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800',
//       className,
//     )}
//     {...props}
//   >
//     className="h-full w-full flex-1 bg-slate-900 transition-all dark:bg-slate-50"
//       style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
//     />
//   </ProgressPrimitive.Root>
// ));
// Progress.displayName = ProgressPrimitive.Root.displayName;

// export { Progress };

'use client';

import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cn } from '@/src/lib/utils/command';

// Define variants for different progress bar styles
const progressVariants = {
  default: {
    background: 'bg-slate-100 dark:bg-slate-800',
    indicator: 'bg-slate-900 dark:bg-slate-50',
  },
  success: {
    background: 'bg-green-100 dark:bg-green-800',
    indicator: 'bg-green-600 dark:bg-green-400',
  },
  error: {
    background: 'bg-red-100 dark:bg-red-800',
    indicator: 'bg-red-600 dark:bg-red-400',
  },
  warning: {
    background: 'bg-yellow-100 dark:bg-yellow-800',
    indicator: 'bg-yellow-600 dark:bg-yellow-400',
  },
  info: {
    background: 'bg-blue-100 dark:bg-blue-800',
    indicator: 'bg-blue-600 dark:bg-blue-400',
  },
};

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    variant?: keyof typeof progressVariants;
  }
>(({ className, value, variant = 'default', ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      'relative h-4 w-full overflow-hidden rounded-full',
      progressVariants[variant].background,
      className,
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn('h-full w-full flex-1 transition-all', progressVariants[variant].indicator)}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
